import React from 'react';
import SafeIcon from '../common/SafeIcon';

const SectionHeader = ({ title, subtitle, icon }) => {
  return (
    <div className="text-center mb-16">
      <div className="flex justify-center items-center gap-3 mb-4 text-moss">
        <div className="h-px w-12 bg-moss/30"></div>
        {icon && <SafeIcon name={icon} className="text-xl" />}
        <div className="h-px w-12 bg-moss/30"></div>
      </div>
      <h2 className="font-serif text-4xl md:text-5xl font-bold text-espresso mb-4">{title}</h2>
      {subtitle && <p className="font-handwriting text-2xl text-gray-600">{subtitle}</p>}
    </div>
  );
};

export default SectionHeader;